var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Edit_Icon",
    "data-name": "Edit Icon",
    transform: "translate(-16 -9)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Base",
    transform: "translate(16 9)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 17,
    height: 17,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Edit",
    transform: "translate(18.467 11.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3113",
    "data-name": "Path 3113",
    d: "M12,46.03a.324.324,0,0,0-.324.324v2.875a.972.972,0,0,1-.971.971H1.619a.972.972,0,0,1-.971-.971V40.791a.972.972,0,0,1,.971-.971H4.494a.324.324,0,0,0,0-.648H1.619A1.621,1.621,0,0,0,0,40.791v8.437a1.621,1.621,0,0,0,1.619,1.619H10.7a1.621,1.621,0,0,0,1.619-1.619V46.353A.324.324,0,0,0,12,46.03Zm0,0",
    transform: "translate(0 -37.912)",
    fill: "#901f89",
    stroke: "#901f89",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3114",
    "data-name": "Path 3114",
    d: "M116.881.687a1.457,1.457,0,0,0-2.06,0l-5.776,5.776a.324.324,0,0,0-.083.143l-.76,2.742a.324.324,0,0,0,.4.4l2.742-.76a.324.324,0,0,0,.143-.083l5.776-5.776a1.459,1.459,0,0,0,0-2.06ZM109.75,6.674l4.727-4.728L116,3.471,111.275,8.2Zm-.3.611L110.664,8.5l-1.685.467ZM116.8,2.67l-.343.343-1.525-1.525.343-.343a.809.809,0,0,1,1.145,0l.38.38A.811.811,0,0,1,116.8,2.67Zm0,0",
    transform: "translate(-104.687 -0.261)",
    fill: "#901f89",
    stroke: "#901f89",
    strokeWidth: 0.3
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.3903324f18d558a17b7508a83e29a0fb.svg";
export { ForwardRef as ReactComponent };